import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import DataTableComponent from '../../../../../../../Util/DataTable/DataTable';
import { loadColumns } from '../../../../../../../Util/helper';
import "./ViewChampions.css";
import dropdown from "../../../../../../../assets/arrow-back.svg";
import axiosApi from '../../../../../../../core/interceptor/interceptor';
import { config } from '../../../../../../../config';

const columns = loadColumns({
	columns: [
		{
			name: 'Awarded',
			selector: 'Champion.awarded',
			type: 'awarded',
		},
		{
			name: 'League',
			selector: 'name',
			type: 'hosted_by'
		},
		{
			name: 'Team',
			selector: 'Champion.name',
		},
		{
			name: 'Captain',
			selector: 'Champion.user.name',
		},
		{
			name: 'Team Status',
			selector: 'Champion.status',
			type: 'status',
		},
	]
});

export default function League() {
	const [season, setSeason] = useState(null);
	const [data, setData] = useState();
	const [filter, setFilter] = useState({
		limit: 50,
		page: 1,
		sort_column: 'created_at',
		direction: 'desc',
		searchString: '',
		season_id: 0,
		status: '',
	});
	const [total, setTotal] = useState(0);

	useEffect(() => {
		let season_ = localStorage.getItem('season_selected');
		if (season_) {
			setSeason(JSON.parse(season_));
		}
	}, []);
	const find = useLocation().search;
	const id = new URLSearchParams(find).get('season_id');
	const [seasonName, setSeasonName] = useState('');



	useEffect(() => {
		const getSeasonInfo = () => {
			axiosApi.get(`${config.apiUrl}/seasons/${id}`).then((res) => {
				
				setFilter(prev => {
					const filter_ = {
						...prev,
						season_id: id,
						season_name: res.data.data.name,
					};
					return filter_;
				});
				setSeasonName(res.data.data.name);
				
			}).catch((err) => {
				console.error(err);
			})
		}
		if(id && id > 0){
			getSeasonInfo();
		}
		
	},[id])

	useEffect(() => {
		if (filter.season_id > 0 ) {
			getChampions(filter);
		}
	}, [filter,
		filter.page,
		filter.sort_column,
		filter.direction,
		filter.limit,
		filter.status,
		filter.season_id
	]);

	function getChampions(params) {
		axiosApi.get(`${config.apiUrl}/leagues/champions/getChampions`, { params })
			.then((resp) => {
				if (resp && resp.data && resp.data.data) {
					setData(resp.data.data);
					setTotal(resp.data.data?.length);
					if (resp.data.data[0]?.season?.name) {
						setSeasonName(resp.data.data[0]?.season?.name);
					}
				}
			});
	}

	const handleChangeTable = (e) => {
		if (e.type === 'sort') {
			setFilter(prev => {
				const filter_ = {
					...prev,
					[e.target.name]: e.target.value,
					direction: e.target.direction,
				};
				return filter_;
			});
		} else {
			setFilter(prev => {
				const filter_ = {
					...prev,
					[e.target.name]: e.target.value,
				};
				return filter_;
			})
		}
	}

	const search = () => {
		getChampions({...filter, 'searchString': filter.searchString.trim(), page: 1 });
	}

	return <>
		<div className="content-wrapper viewChampion-wrapper">
			<div className="heading-blk">
				<Link to={
					{
						pathname: '/admin/leagues',
						state: {
							season_name: season && season.name ? season.name : '',
							season_id: season && season.id ? season.id : (id ? id : ''),
						}
					}
				}><button className="back-btn"><img src={dropdown} alt="dropdown" />Back to Overview</button></Link>
			</div>
			<div className="heading-blk heading">
				<div className="left">
					<h2>Champions - {seasonName}</h2>
				</div>
			</div>
			<div className="table-wrapper">
				<div className="search-blk league-search">
					<h2>Champion Filters</h2>
					<div className="input-blk">
						<div className="search-bar">
							<div className="input-field">
								<label>Search</label>
								<input type="text" id="search_bar" name="search" value={filter.searchString} onChange={(e) => setFilter(prev => ({ ...prev, searchString: e.target.value }))} placeholder="Search by league, team, captain..." />
							</div>
							<div className="button-wrapper-search">
								<button type='submit' onClick={search}>Search</button>
							</div>
						</div>
						{/* <div className="drop-wrapper">
							<CustomSelect
								label={'Status'}
								data={[
									{
										id: '',
										title: 'All'
									},
									{
										id: 'active',
										title: 'Active'
									},
									{
										id: 'complete',
										title: 'Complete'
									},
									{
										id: 'cancel',
										title: 'Cancel'
									},
									{
										id: 'sign_up',
										title: 'Sign-up'
									},
									{
										id: 'need_schedule',
										title: 'Needs Schedule',
									},
									{
										id: 'archive',
										title: 'Archive'
									}
								]}
								placeholder={filter.status ? LEAGUE_STATUS[filter.status] : 'All'}
								type={'status'}
								onSelect={(ele) => ele && setFilter(prev => ({ ...prev, status: ele.id }))}
								selector="title"
							/>
						</div> */}
					</div>
				</div>
				<div className="heading-blk">
					<div className="left">
						<h2>Results</h2>
						<p>Select a league to view winning team roaster and assign award.</p>
					</div>
				</div>
				<div className="dataTable">
					<DataTableComponent
						key="table-admin-users"
						type={'league_champions_team'}
						data={data}
						columns={columns}
						onFilterChange={handleChangeTable}
						totalPage={total} />
				</div>
			</div>
		</div>
	</>
}